import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const TextTag = styled.div<IWithSize>`
  caret-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  margin-right: ${({ size }) => (size ? 8 * size : 8)}px;
  font-weight: bold;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  padding-bottom: ${({ size }) => (size ? 10 * size : 10)}px;
  border: none;
  outline: none;
  max-width: 100%;
`

export default TextTag
